/**
 * Promise feature polyfills
 */

/**
 * Polyfill for Promise.withResolvers
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers
 */
function polyfillPromiseWithResolvers() {
  if (
    typeof Promise !== 'undefined' &&
    typeof Promise.withResolvers !== 'function'
  ) {
    Promise.withResolvers = function withResolvers() {
      let resolve;
      let reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, resolve, reject };
    };
  }
}

// Apply polyfills
polyfillPromiseWithResolvers();

// Export for CommonJS only - no ES Module exports
module.exports = {
  polyfillPromiseWithResolvers,
};
